import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import FormInput from "../form/FormInput";
import FormButton from "../form/FormButton";
import useRemoveAdmin from "../../api/teachers/useRemoveAdmin";
import { selectCalendar } from "../../../redux/slices/school/selectors";

export default function RemoveAdmin({ details, closeSideModal }) {
    const { schoolId } = useParams();
    const currentCalendar = useSelector(selectCalendar);

    const { request, loading } = useRemoveAdmin();

    async function handleContinue() {
        const isSuccess = await request(
            {
                teacherId: details?.userId,
                calendarId: currentCalendar?.calendarId,
            },
            schoolId
        );

        if (isSuccess) {
            closeSideModal({ refresh: true });
        }
    }

    return (
        <div>
            <h1 className="side_page_title">Remove Admin</h1>

            <p className="text-dark_electric_blue text-sm mb-2">
                Revoke admin access to your school
            </p>

            <p className="text-sm text-independence mb-1">
                - User will be removed from your list of admins
            </p>

            <p className="text-sm text-independence mb-1">
                - All access to the school will be terminated
            </p>

            <p className="text-sm text-independence mb-1">
                - Existing class and subject roles remains unchanged
            </p>

            <div className="max-w-md my-10">
                <FormInput
                    disabled
                    placeholder={`${details?.title} ${details?.lastName} ${details?.firstName}`}
                />

                <FormButton
                    loading={loading}
                    onClick={handleContinue}
                    title={"Revoke Admin"}
                    className={"!bg-coral_red mt-5"}
                />
            </div>
        </div>
    );
}
